import type { Window } from '../../shared/model/tsTypes';

const toHashCode = (s: string): number =>
  // eslint-disable-next-line no-bitwise
  s.split('').reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);

export const generateSearchId = (searchFilters: string): string => {
  const sessionId = (window as Window)?.utag?.data['cp.utag_main_ses_id'];

  if (!sessionId) {
    return '';
  }

  return (toHashCode(sessionId).toString(36) + toHashCode(searchFilters).toString(36)).replace(
    /[^a-zA-Z0-9 ]/g,
    '',
  );
};
